// extracted by mini-css-extract-plugin
export default {"wrapper":"SnapshotBar_wrapper__zcK92","bar":"SnapshotBar_bar__TkqBB"};